module.exports = __webpack_public_path__ + "img/The Water Club.27dd041c.png";